import i18n from "../../../../../i18n";
import { reactive } from "vue";
import store from "../../../../../store/index";

import { defineAsyncComponent } from "vue";
import {
    createButtonCreate
} from "../../../../../utils/button";
import {
    createManageDelete,
    createManageExportCsv,
    createPage,
    createRowActionEdit,
    createRowActionView,
    createRowActionDelete
} from "../../../../../utils/page";
import {
    conditionFormChecker,
    onClickDeleteAllClient
} from "../../../../../utils/form";

import { has } from "../../../../../utils/menu-context";

export const { isLoading, setIsLoading } = createLoading();

const CIcon = defineAsyncComponent(() => import("../../../../../components/icon/CIcon"));
const CIFrame = defineAsyncComponent(() => import('../../../../../components/iframe/CIFrame'))

import {
    createColumnInlineRadioGroup,
    createColumnInlineSelect,
    createColumnInput
} from "../../../../../components/table/c-table.logic";
import { addModal } from "../../../../../app.logic";
import lodash from "lodash";
import { modalStyleForm, modalStyleIFrame } from "../../../../../utils/constant";
import { openModalList as openModalListTopic } from "../../../master-mgt/lab/topic/topic-list.logic";
import { onIFrameClickSelectAll } from "../../../../../utils/iframe";
import { addRules, clearRulesStartsWith, requiredWhen, validateError } from "../../../../../utils/validate";
import { Button, Modal } from "ant-design-vue";
import { callAcceptStatus, calResultAnalysisTopic } from "../physical-analysis/physical-analysis.logic";
import { createLoading } from '../../../../../utils/loading';
import { createForm as createFormTopicInput } from '../physical-analysis-topic-input/physical-analysis-topic-input-form.logic'

export const callSearchTopicByParent = ({ parentId, labTypeKye }) => store.dispatch(`resource/v1/master/labTopic/findAllByParent`, { parentId, labTypeKye });

export const actionPrefix = "resource/v1/transaction/samplingProductAnalysisTopic";
export const routerPrefix = "lab-physic-sampling-product-analysis-exports";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id });
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id });
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, {
    id,
    config: { params: { isHardDelete: true } }
});
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids });
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, {
    ids,
    config: { params: { isHardDelete: true } }
});

export const getRepeatOption = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "LAB_REPEAT_OPTION", value: searchQuery });
export const PhysicalAnalysisTopicMultiInputForm = defineAsyncComponent(() => import("../physical-analysis-topic-input/PhysicalAnalysisTopicMultiInputForm"));
export const PhysicalAnalysisTopicIntegrityForm = defineAsyncComponent(() => import("../physical-analysis-topic-input/PhysicalAnalysisTopicInputForm"));

export const openSamplingProductAnalysisModalForm = ({ bind, analysis }) => {
    const extCenterTypeKey = analysis?.refExtCenterType?.key;
    const urlPath = extCenterTypeKey === 'Cross Center' ? `/lab-physic/analysis-cross-centers/${analysis.id}/view`: extCenterTypeKey === 'Lab Ext' ? `/lab-ext/lab-physic-sampling-product-analysiss/${analysis.id}/view`  : ''

    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleIFrame), bind),
        render: () => <CIFrame src={`${process.env.VUE_APP_PUBLIC_PATH}/app${urlPath}?isLayout=false&canCreate=false`}></CIFrame>
    })
    return options
}

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria) {
        return Promise.resolve({ data: [] });
    }
    setIsLoading(true);
    return callSearch(fetchCriteria).finally(() => {
        setIsLoading(false)
    });
};


export const createColumns = ({ props }) => {
    const { useForm, itemsKey, acceptStatus, refExtCenterTypeKey, refSamplingRequestTypeKey } = props;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    return [
        createColumnInput({
            title: () => i18n.global.t("model.topic.modelName"),
            dataIndex: "refLabTopic.name",
            align: "center"
        }),
        createColumnInlineRadioGroup({
            title: () => i18n.global.t("model.samplingProductAnalysisTopic.refTopicAnalysisStatus"),
            dataIndex: "refTopicAnalysisStatus",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({
                list: callAcceptStatus,
                optLabel: "value"
            }),
            customRenderInputProp: ({ record, key }) => {
                return {
                    disabled: conditionFormChecker({
                        props,
                        data: props,
                        executeKey: "disableTopicAnalysisStatusField",
                        params: { record, field: { key: key } }
                    }),
                    list: ({searchQuery}) => callAcceptStatus({searchQuery}).then(arr => arr.filter(it => it.key != 'RejectCanRepeat')),
                    optLabel: "value",
                    "onUpdate:value": (value) => {
                        record.isSave = true;
                        record.refTopicAnalysisStatus = value;
                        if (!refSamplingRequestTypeKey.includes("M")) {
                            record.refCountry1TopicAnalysisStatus = value;
                            record.refCountry2TopicAnalysisStatus = value;
                        }
                        calResultAnalysisTopic({ useForm, acceptStatus });
                    }
                };
            },
            align: "center"
        }),
        createColumnInlineSelect({
            visible: () => !refSamplingRequestTypeKey.includes("M"),
            title: () => i18n.global.t("model.samplingProductAnalysisTopic.refTopicRepeatOption"),
            dataIndex: "refTopicRepeatOption",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: getRepeatOption }),
            customRenderInputProp: ({ record, key }) => {
                return lodash.merge({
                            list: getRepeatOption,
                            "onUpdate:value": (value) => {
                                record.refTopicRepeatOption = value
                                calResultAnalysisTopic({ useForm, acceptStatus })
                            },
                            optLabel: 'value',
                        }, conditionFormChecker({ props, data: props, executeKey: "customRenderInputProp", params: { record, field: { key: key } } }))
                },
            align: "center"
        }),
        createColumnInput({
            visible: () => !refExtCenterTypeKey,
            title: () => i18n.global.t("model.samplingProductAnalysisTopic.isTransfer"),
            dataIndex: "isTransfer",
            customRender: ({record}) => {
                const jsx = record.transferTos?.map(d => {
                    const refLabAnalysisStatus = d.refSamplingProductAnalysis?.refLabAnalysisStatus;
                    const btn = refLabAnalysisStatus?.key !== 'Send Result' ?
                        <span>({refLabAnalysisStatus?.value})</span>
                        : <Button class="btn-info m-1" size="small"
                                  onClick={() => openSamplingProductAnalysisModalForm({ props, analysis: d.refSamplingProductAnalysis })}>
                            <CIcon file="eye.svg"></CIcon>
                        </Button>;
                    return <div>
                        {btn}
                        <span>{d.refSamplingProductAnalysis?.refDepartment?.nameTh || d.refSamplingProductAnalysis?.refLabExt?.nameTh}</span>
                    </div>;
                }) || [];
                //
                // const jsx = record.transferTos?.map(d => {
                //     if (!d.refSamplingProductAnalysis?.reviewDate)  {
                //         return <div class="text-center">
                //             <span>{i18n.global.t('model.samplingProductAnalysis.labels.wait')  + " (" + d.refSamplingProductAnalysis?.refDepartment?.nameTh || d.refSamplingProductAnalysis?.refLabExt?.nameTh  + ")" }</span>
                //         </div>
                //     } else if (!d.refSamplingProductAnalysis?.approveDate)  {
                //         return <div class="text-center">
                //             <span>{i18n.global.t('model.samplingProductAnalysis.labels.waitApprove') + " (" + d.refSamplingProductAnalysis?.refDepartment?.nameTh || d.refSamplingProductAnalysis?.refLabExt?.nameTh + ")"}</span>
                //         </div>
                //     } else if(d?.refSamplingProductAnalysis?.approveDate) {
                //         return <div class="text-center">
                //             <Button class="btn-info m-1" size="small" onClick={() => openSamplingProductAnalysisModalForm({ props, analysis: d.refSamplingProductAnalysis })}>
                //                 <CIcon file="eye.svg"></CIcon>
                //             </Button>
                //             <span>{d.refSamplingProductAnalysis?.refDepartment?.nameTh}</span>
                //         </div>
                //     } else {
                //         return <div></div>
                //     }
                // }) || []
                return <div>{...jsx}</div>
            }
        }),
    ];
};

export const createRulesAnalysisTopic = ({ useForm, itemsKey, dataProp }) => {
    const { modelRef } = useForm;
    const model = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    clearRulesStartsWith({ useForm, key: `${itemsKey}` });
    model?.forEach((input, index) => {
        addRules({ useForm, modelRef, key: `${itemsKey}.${index}.refTopicAnalysisStatus`, rules: [requiredWhen({ when: () => dataProp.isValidateForm })] });
        addRules({ useForm, modelRef, key: `${itemsKey}.${index}.refTopicRepeatOption`, rules: [requiredWhen({ when: () => dataProp.isValidateForm })] });
    });
};

export const openModalForm = ({ props, items }) => {
    const refs = reactive({ form: null });
    const { form, useForm, acceptStatus, dataProp } = props;
    let options;
    if (form.refLabTopic.refLabFormula.key == "Weight") {
        const validateWeightInput = [];
        validateWeightInput.push("samplingAmount")
        if (form.refLabTopic.nameS == "NW"  && !props.viewOnly) {
            dataProp.isValidateNW = true;
            validateWeightInput.push("netWeight")
            validateWeightInput.push("refNetWeightUnit")
        } else if (form.refLabTopic.nameS == "NV" && !props.viewOnly) {
            dataProp.isValidateNV = true;
            validateWeightInput.push("netVolume")
            validateWeightInput.push("refNetVolumeUnit")
        } else if (form.refLabTopic.nameS == "DW" && !props.viewOnly) {
            dataProp.isValidateDW = true;
            validateWeightInput.push("drainWeight")
            validateWeightInput.push("refDrainWeightUnit")
        }
        useForm.validate(validateWeightInput)
            .then(() => {
                options = addModal({
                    bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
                        okButtonProps: { disabled: props.viewOnly },
                        header: i18n.global.t("model.samplingProduct.modelName"),
                        onOk: () => {
                            refs.form.callOnClickModalOk()
                                .then((record) => {
                                    record.isSave = true;
                                    if (items) {
                                        items.push(record);
                                    } else {
                                        lodash.merge(props.form, record);
                                        calResultAnalysisTopic({ useForm, acceptStatus });
                                    }
                                    options.bind.onCancel();
                                });
                        }
                    }),
                    render: () => <PhysicalAnalysisTopicMultiInputForm ref={(e) => {
                        if (e) refs.form = e;
                    }} {...props}></PhysicalAnalysisTopicMultiInputForm>
                });
            })
            .catch((error) => {
                validateError({ error });
                throw error;
            });

    } else if (form.refLabTopic.refLabFormula.key == "Integrity" || form.refLabTopic.refLabFormula.key == "Acceptance") {
        options = addModal({
            bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
                okButtonProps: { disabled: props.viewOnly },
                header: i18n.global.t("model.samplingProduct.modelName"),
                onOk: () => {
                    refs.form.callOnClickModalOk()
                        .then((record) => {
                            record.isSave = true;
                            if (items) {
                                items.push(record);
                            } else {
                                lodash.merge(props.form, record);
                                calResultAnalysisTopic({ useForm, acceptStatus });
                            }
                            options.bind.onCancel();
                        });
                }
            }),
            render: () => <PhysicalAnalysisTopicIntegrityForm ref={(e) => {
                if (e) refs.form = e;
            }} {...props} ></PhysicalAnalysisTopicIntegrityForm>
        });
    }
    return options;
};

export const initData = ({ data, props }) => {
    const { menuContext, viewOnly, parent, useForm, itemsKey, acceptStatus, dataProp, refSamplingRequestTypeKey, repeatOption } = props;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: parent.topics });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => has({ menuContext, key: "canDelete" }),
            onClick: ({ rowSelection }) => onClickDeleteAllClient({ rowSelection, items: items })
        }),
        createManageExportCsv({ menuContext })
    ];
    data.manageExtras = [];
    data.rowActions = [];
    data.manageExtras.push({
        render: () => ({
            ...createButtonCreate({
                onClick: () => openModalListTopic({
                    onIframeMounted: ({ refs, options }) => onIFrameClickSelectAll({
                        refs,
                        options,
                        items: parent.topics,
                        itemKey: "refLabTopic.id",
                        rowKey: "id",
                        setKey: "refLabTopic",
                        afterSelect: ({ rowSelection }) => {
                            parent.topics.map(topic => {
                                const selectionRow = rowSelection.selectedRows.filter(selectedRow => selectedRow.id == topic.refLabTopic.id )[0];
                                if (selectionRow) {
                                    if (refSamplingRequestTypeKey.includes("M")) {
                                        lodash.set(topic, "refTopicRepeatOption", repeatOption.filter(it => it.key == 'Unrepeatable')[0]);
                                    } else {
                                        lodash.set(topic, "refTopicRepeatOption", topic.refLabTopic.refRepeatOption);
                                    }
                                    if (topic?.refLabTopic?.refLabFormula?.key == 'Weight') {
                                        lodash.set(topic, "inputs", []);
                                    }
                                    if (selectionRow.children?.length) {
                                        lodash.set(topic, "children", []);
                                        if (selectionRow?.haveChildren) {
                                            callSearchTopicByParent({ parentId: selectionRow.id, labTypeKey: 'labPhysic' }).then(list => {
                                                list.map(labTopic => {
                                                    topic.children.push({
                                                        ...createFormTopicInput,
                                                        isSave: true,
                                                        refLabTopic: labTopic,
                                                        children: null
                                                    })
                                                } )
                                            })
                                        }
                                    }
                                }
                            });
                            createRulesAnalysisTopic({ useForm, itemsKey, dataProp });
                            calResultAnalysisTopic({ useForm, acceptStatus })
                        },
                        onSearch: ({ whereAll }) => {
                            const value = modelRef.topics.filter(d => d.isDelete !== true).map(d => lodash.get(d, "refLabTopic.id"))
                            if (value.length > 0) {
                                whereAll.push({ name: "id", type: 'UUID', operator: '!in', value })
                            }
                            whereAll.map(it => {
                                if (it.name == 'refParent.id') {
                                    it.value = null;
                                }
                                if (it.name == 'refLabType.key') {
                                    it.value.filter(labType => labType == 'labPhysic')
                                }
                            });
                        },
                    }),
                    disabledSearch: ['refParent.id'],
                    isForceInvisibleSearch: true,
                    viewOnly
                }),
                options: { text: i18n.global.t("model.topic.modelName") },
            })
        }),
        visible: () => has({ menuContext, key: "canCreate" }) && !viewOnly
    });
    data.rowActions.push(createRowActionView({
        menuContext,
        visible: ({ record }) => !(record.refLabTopic.refLabFormula.key == "Acceptance" && !record.refLabTopic.haveChildren),
        onClick: ({ record }) => {
            if (record.refLabTopic.refLabFormula.key == "Acceptance" && !record.refLabTopic.haveChildren) {
                return;
            }
            openModalForm({
                props: {
                    menuContext,
                    viewOnly: true,
                    setAppPageHeader: false,
                    form: record,
                    parent,
                    useForm,
                    acceptStatus,
                    dataProp,
                }
            });
        }
    }));
    if (!viewOnly) {
        data.rowActions.push(createRowActionEdit({
            menuContext,
            visible: ({ record }) => !(record.refLabTopic?.refLabFormula?.key == "Acceptance" && !record.refLabTopic?.haveChildren) || record.transferTos?.length > 0,
            onClick: ({ record }) => {
                if (record.refLabTopic?.refLabFormula?.key == "Acceptance" && !record.refLabTopic?.haveChildren) {
                    return;
                }
                openModalForm({
                    props: {
                        menuContext,
                        viewOnly: viewOnly,
                        setAppPageHeader: false,
                        form: record,
                        parent,
                        useForm,
                        acceptStatus,
                        dataProp,
                    }
                });
            }
        }));
        data.rowActions.push(createRowActionDelete({
            menuContext,
            onClick: ({ record }) => {
                Modal.confirm({
                    title: i18n.global.t("components.table.operatorAndPagination.youAreWant", { text: i18n.global.t("button.delete") }),
                    autoFocusButton: "cancel",
                    okType: "danger",
                    onOk: () => {
                        clearRulesStartsWith({ useForm, key: itemsKey });
                        onClickDeleteAllClient({ rowSelection: { selectedRows: [record] }, items: items });
                        calResultAnalysisTopic({ useForm, acceptStatus });
                    }
                });
            }
        }));
    }

    fetchData({ props, data }).then(page => {
        props.parent.topics.push(...page.data);
        createRulesAnalysisTopic({ useForm, itemsKey, dataProp });
    });
};

